module.exports = __webpack_public_path__ + "img/646.b2a641d6.png";